import { CheckOutlined } from '@ant-design/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getPageContentFeatures } from '../../../../entities/PageContent'
import { PageSection } from '../../../../shared/ui/PageSection'
import cls from './FeaturesSection.module.scss'

const FeaturesSection: React.FC = () => {
    const { t, i18n } = useTranslation()
    const featuresSection = useSelector(getPageContentFeatures)
    const fallbackFeatures: string[] = t('features.list', {
        returnObjects: true
    })
    const lang = i18n.language.split('-')[0]
    const isRu = lang === 'ru'

    const title = featuresSection
        ? isRu
            ? featuresSection.titleRu
            : featuresSection.titleEn
        : t('features.title')

    const features =
        featuresSection?.items?.map((item) =>
            isRu ? item.textRu : item.textEn
        ) ?? fallbackFeatures

    return (
        <PageSection
            title={title}
            align="start"
            style={{ backgroundColor: 'var(--bg-base)' }}
        >
            <ul className={cls.list}>
                {features.map((item, index) => (
                    <li
                        key={featuresSection?.items?.[index]?.id ?? index}
                        className={cls.item}
                    >
                        <span className={cls.check} aria-hidden>
                            <CheckOutlined />
                        </span>
                        {item}
                    </li>
                ))}
            </ul>
        </PageSection>
    )
}

export default FeaturesSection
